import { serverApi } from "../../lib/config";
import { Product, ProductInquiry, ProductPage } from "../../lib/types/product";
import axios from "axios";

class ProductService {
  private readonly path: string;

  constructor() {
    this.path = serverApi;
  }

  public async getProducts(input: ProductInquiry): Promise<Product[]> {
    const page = await this.getProductsPage(input);
    return page.items;
  }

  public async getProductsPage(input: ProductInquiry): Promise<ProductPage> {
    try {
      let url = `${this.path}/product/all?order=${input.order}&page=${input.page}&limit=${input.limit}`;
      const genre = input.productGenre || input.productCollection;
      if (genre) url += `&productGenre=${genre}`;
      if (input.search) url += `&search=${encodeURIComponent(input.search)}`;

      const result = await axios.get(url);
      const data = result.data;
      if (Array.isArray(data)) {
        return {
          items: data,
          total: data.length,
          page: input.page,
          pages: 1,
          limit: input.limit,
        };
      }
      return data;
    } catch (err) {
      console.log("Error, getProducts:", err);
      throw err;
    }
  }

  public async getPopular(limit = 4): Promise<Product[]> {
    const result = await axios.get(`${this.path}/product/popular?limit=${limit}`);
    return result.data;
  }

  public async getNewArrivals(limit = 4): Promise<Product[]> {
    const result = await axios.get(`${this.path}/product/new?limit=${limit}`);
    return result.data;
  }

  public async getProduct(productId: string): Promise<Product> {
    try {
      const url = `${this.path}/product/${productId}`;
      const result = await axios.get(url, { withCredentials: true });
      return result.data;
    } catch (err) {
      console.log("Error getProduct:", err);
      throw err;
    }
  }
}

export default ProductService;
